import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import { useFormCreateProductBrands } from '../../controllers/ProductBrands/CreateProductBrandsController';
import LoadingScreen from '../../components/LoadingScreen';

const ProductBrandForm: React.FC = () => {
	const { getProductBrandFormController, handleProductBrandFormController } = useFormCreateProductBrands();
	const history = useHistory();

	const [registerFinished, setRegisterFinished] = useState(false);

	useEffect(() => {
		if (getProductBrandFormController.ProductbrandResponse?.status === 200) {
			setRegisterFinished(true);
		}
		if (
			getProductBrandFormController.ProductbrandEditedResponse?.status === 200 &&
			!getProductBrandFormController.ProductbrandResponse
		) {
			setRegisterFinished(false);
		}
	}, [getProductBrandFormController.ProductbrandResponse, getProductBrandFormController.ProductbrandEditedResponse]);

	return (
		<div style={{ height: '100%' }} className='p-grid p-align-center p-justify-center'>
			<Toast ref={getProductBrandFormController.toast} />
			{getProductBrandFormController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			<div className='p-col-12 p-md-8'>
				<div className='card p-fluid'>
					<h5>Marca de Produtos</h5>
					<div className='p-field'>
						<label htmlFor='name'>Nome</label>
						<InputText
							id='name'
							type='text'
							maxLength={150}
							disabled={registerFinished}
							value={getProductBrandFormController.formik.values.DESCRICAO}
							onChange={getProductBrandFormController.formik.handleChange('DESCRICAO')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getProductBrandFormController.formik.touched.DESCRICAO &&
									getProductBrandFormController.formik.errors.DESCRICAO,
								'popup-form-inactive': !(
									getProductBrandFormController.formik.touched.DESCRICAO &&
									getProductBrandFormController.formik.errors.DESCRICAO
								),
							})}>
							{getProductBrandFormController.formik.errors.DESCRICAO}
						</div>
					</div>
					<div className='p-fluid p-grid p-justify-between'>
						{getProductBrandFormController.ProductbrandResponse?.status === 200 && !registerFinished ? (
							<div className='p-col-12 p-md-4'>
								<Button
									type='button'
									label='Salvar Alterações'
									onClick={() => {
										getProductBrandFormController.formik.handleSubmit();
									}}
								/>
							</div>
						) : getProductBrandFormController.ProductbrandResponse?.status === 200 && registerFinished ? (
							<div className='p-col-12 p-md-6 p-fluid p-grid'>
								<div className='p-col-12 p-md-5'>
									<Button
										type='button'
										label='Editar'
										onClick={() => {
											setRegisterFinished(false);
										}}
									/>
								</div>
								<div className='p-col-12 p-md-5'>
									<Button
										icon='pi pi-plus'
										type='button'
										className='p-button-success'
										label='Cadastrar novo'
										onClick={() => {
											getProductBrandFormController.formik.resetForm();
											setRegisterFinished(false);
											handleProductBrandFormController.setProductBrandResponse(null);
										}}
									/>
								</div>
							</div>
						) : (
							<div className='p-col-12 p-md-4'>
								<Button
									type='button'
									label='Cadastrar'
									onClick={() => getProductBrandFormController.formik.handleSubmit()}
								/>
							</div>
						)}

						<div className='p-col-12 p-md-4'>
							<Button
								type='button'
								className='p-button-secondary'
								label='Voltar para listagem'
								onClick={() => history.goBack()}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProductBrandForm;
